import { Suspense, useEffect } from 'react';
import { InteractionStatus } from '@azure/msal-browser';
import { IMsalContext, useMsal } from '@azure/msal-react';
import LoadingScreen from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/LoadingScreen';
import { AuthStrategy } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/api-util';
import MaybeLwtErrorBoundary from '@monorepo/shared/src/components/common/MaybeLwtErrorBoundary';
import { hasAuthCookies } from '@monorepo/shared/src/util/auth-cookie-util';
import { getApi } from '@monorepo/shared/src/api/';
import { getAccessToken } from '@monorepo/shared/src/config/educatorApp/auth';
import useUserStore from '@monorepo/shared/src/graph/hooks/use-user';
import AuthenticatedApp from './AuthenticatedApp';

const setAuthContext = async (azureContext: IMsalContext): Promise<void> => {
  const result = await getAccessToken(azureContext);
  result && getApi(AuthStrategy.HTTP_AUTHENTICATION).setAuthContext(result);
};

const GatedApp: React.FC = () => {
  const azureContext = useMsal();
  const [user] = useUserStore();
  const doesNotHaveAuthCookies = !hasAuthCookies();

  useEffect(() => {
    if (doesNotHaveAuthCookies) {
      const authorizeUser = async () => await setAuthContext(azureContext);
      authorizeUser();
    }
  }, [azureContext]);

  const showLoading =
    (doesNotHaveAuthCookies && azureContext.inProgress !== InteractionStatus.None) ||
    user.isAuthenticating ||
    !user.isAuthenticated;

  return showLoading ? (
    <LoadingScreen />
  ) : (
    <Suspense fallback={<LoadingScreen />}>
      <MaybeLwtErrorBoundary>
        <AuthenticatedApp />
      </MaybeLwtErrorBoundary>
    </Suspense>
  );
};

export default GatedApp;
